import {
    GET_SESSIONS_FAIL,
    GET_SESSIONS_SUCCESS,
    ADD_SESSION_SUCCESS,
    ADD_SESSION_FAIL,
    UPDATE_SESSION_SUCCESS,
    UPDATE_SESSION_FAIL,
    DELETE_SESSION_SUCCESS,
    DELETE_SESSION_FAIL,

    GET_SESSION_RESULTS,
    GET_SESSION_RESULTS_SUCCESS,
    GET_SESSION_RESULTS_FAIL,

    PROCLAMER_SESSION,
    PROCLAMER_SESSION_SUCCESS,
    PROCLAMER_SESSION_FAIL,

    GET_PROCLAMATION_RESULTS,
    GET_PROCLAMATION_RESULTS_SUCCESS,
    GET_PROCLAMATION_RESULTS_FAIL,

    SAVE_FINAL_DECISION,
    SAVE_FINAL_DECISION_SUCCESS,
    SAVE_FINAL_DECISION_FAIL,

    RUN_ANNUAL_DELIBERATION,
    RUN_ANNUAL_DELIBERATION_SUCCESS,
    RUN_ANNUAL_DELIBERATION_FAIL,

} from "./actionTypes";

const INIT_STATE = {
    // Sessions (Paramétrage)
    sessions:           [],
    loading:            false,
    lastActionSuccess:  false,
    error:              null,
    success:            false,

    // ============================================================
    // 1. FLUX TRAVAIL (Tableau Result.js / Recherche)
    // ============================================================
    sessionResults: [], // Données de getResults (notes brutes)
    ueColumns:      [], // Colonnes de getResults
    sessionInfo:    null,

    // ============================================================
    // 2. FLUX PROCLAMATION (PDF & Verrouillage uniquement)
    // ============================================================
    isProclaimed:        false, // Flag 'exists' (État du bouton)
    isProclaiming:       false, // Pendant le calcul store
    loadingProclamation: false, // Pendant le check index
    proclamationResults: [],    // Données officielles (PV Final)
    proclamationStats:   null,
    proclamationMessage: "",

    // Décisions finales
    loadingFinalDecision: false,
    finalDecisions:       [],

    annualDeliberationSuccess: false, // Indispensable pour l'UI
    annualDeliberationData: null,    // Pour stocker session_id et academic_year_id
};

const sessionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

        // --- SESSIONS CRUD ---
        case GET_SESSIONS_SUCCESS:
            return { ...state, sessions: action.payload, loading: false, error: null };
        case GET_SESSIONS_FAIL:
            return { ...state, error: action.payload, loading: false };
        case ADD_SESSION_SUCCESS:
            return { ...state, sessions: [action.payload, ...state.sessions], error: null, success: true };
        case ADD_SESSION_FAIL:
            return { ...state, error: action.payload, success: false };
        case UPDATE_SESSION_SUCCESS:
            return {
                ...state,
                sessions: state.sessions.map(s => s.id.toString() === action.payload.id.toString() ? action.payload : s),
                error: null, success: true
            };
        case UPDATE_SESSION_FAIL:
            return { ...state, error: action.payload, success: false };
        case DELETE_SESSION_SUCCESS:
            return { ...state, sessions: state.sessions.filter(s => s.id !== action.payload), error: null };
        case DELETE_SESSION_FAIL:
            return { ...state, error: action.payload };
        case "RESET_LAST_ACTION_SUCCESS":
            return { ...state, success: false };

        // ============================================================
        // SESSION RESULTS (LE TABLEAU DE TRAVAIL)
        // ============================================================
        case GET_SESSION_RESULTS:
            return {
                ...state,
                loading: true,
                // On ne réinitialise PAS isProclaimed ici pour éviter que 
                // le bouton ne clignote pendant une recherche.
            };

        
        case GET_SESSION_RESULTS_SUCCESS:
            return {
                ...state,
                loading: false,
                // On met à jour uniquement ce qui concerne le TABLEAU
                sessionResults: action.payload.results || [],
                ueColumns:      action.payload.ue_columns || [],
                sessionInfo:    action.payload.session,
            };

        case GET_SESSION_RESULTS_FAIL:
            return { ...state, loading: false, error: action.payload };

        // ============================================================
        // PROCLAMATION (LE BOUTON ET LE PDF)
        // ============================================================
        case GET_PROCLAMATION_RESULTS:
            return { ...state, loadingProclamation: true };

        case GET_PROCLAMATION_RESULTS_SUCCESS:
            return {
                ...state,
                loadingProclamation: false,
                // Stockage dans des variables dédiées (n'affecte pas le tableau)
                //proclamationResults: action.payload.sessionResults || [], 
                proclamationResults: action.payload.results || [],
                proclamationStats:   action.payload.stats || null,
                isProclaimed:        action.payload.exists || false, // Flag pour le bouton
                error: null
            };

        case GET_PROCLAMATION_RESULTS_FAIL:
            return { ...state, loadingProclamation: false, error: action.payload };

        case PROCLAMER_SESSION:
            return { ...state, isProclaiming: true };

        case PROCLAMER_SESSION_SUCCESS:
            return {
                ...state,
                isProclaiming: false,
                isProclaimed: true,
                proclamationMessage: action.payload?.message || "Succès"
            };

        case PROCLAMER_SESSION_FAIL:
            return { ...state, isProclaiming: false, error: action.payload };

        case "RESET_PROCLAMATION_STATUS":
            return { ...state, isProclaimed: false, isProclaiming: false, error: null };

        // --- DÉCISIONS FINALES ---
        case SAVE_FINAL_DECISION:
            return { ...state, loadingFinalDecision: true };
        case SAVE_FINAL_DECISION_SUCCESS:
            return { ...state, loadingFinalDecision: false, isFinalDecisionSaved: true };
        case SAVE_FINAL_DECISION_FAIL:
            return { ...state, loadingFinalDecision: false, error: action.payload };
        
        // ANNUAL DELIBERATION
        case RUN_ANNUAL_DELIBERATION:
            //return { ...state, loading: true, success: false };
            return { ...state, loading: true, annualDeliberationSuccess: false };
        case RUN_ANNUAL_DELIBERATION_SUCCESS:
            return { 
                ...state, 
                loading: false, 
                annualDeliberationSuccess: true, // État immédiat (Action)
                annualDeliberationData: action.payload.data 
            };
        case RUN_ANNUAL_DELIBERATION_FAIL:
            return { ...state, loading: false, error: action.payload, success: false };

        default:
            return state;
    }
};

export default sessionReducer;